import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sheet-choosed",
  "use": "sheet-choosed-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"sheet-choosed\">\n<path d=\"M3.69828 8.64641C3.50302 8.45114 3.18644 8.45114 2.99117 8.64641C2.79591 8.84167 2.79591 9.15825 2.99117 9.35351L5.99117 12.3535C6.18644 12.5488 6.50302 12.5488 6.69828 12.3535L14.0316 5.02018C14.2269 4.82492 14.2269 4.50833 14.0316 4.31307C13.8364 4.11781 13.5198 4.11781 13.3245 4.31307L6.34473 11.2929L3.69828 8.64641Z\" fill=\"#5587F0\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol